import styled from 'styled-components';
import { cssColorValue, semanticColors, spacer16, spacer8, Text } from '@spotify-internal/encore-web';
import React from 'react';

import { srcSetForImage, urlForImage } from 'utils/sanity';

import { CategoryCardComponent } from './CategoryCardComponent';

const Card = styled.div`
  height: 100%;
  line-height: 1;
  display: flex;
  flex-direction: column;
  padding: ${spacer16};
  gap: ${spacer8};
  border: 1px solid ${cssColorValue(semanticColors.decorativeSubdued)};
  border-radius: 4px;

  // To accomodate languages with long words:
  word-break: break-word;
  hyphens: auto;

  &:hover {
    box-shadow: inset 0 0 0 1px ${cssColorValue(semanticColors.essentialBase)};
  }
`;

export const TopImageCategoryCard: CategoryCardComponent = ({ category, vertical }) => (
  <Card>
    <img
      alt={category.title ?? undefined}
      srcSet={srcSetForImage({ source: category.image.asset, maxWidth: 24, vertical })}
      src={urlForImage({ source: category.image.asset, maxWidth: 24, vertical })}
      aria-hidden="true"
      width={24}
      height={24}
    />
    <Text variant="bodyMediumBold">{category.title}</Text>
  </Card>
);
